import { purchaseCents } from '../equipment-integration/equipmentMapper';
import type { QuoteSelectionDevice } from '../pages/cpq-v2/state/types';

export function purchasePriceSnapshotCents(
  device: QuoteSelectionDevice,
  basis: 'tax13' | 'exTax13',
): number | null {
  // The public tuple field name is retained for contract compatibility. Its
  // source is the maintained plan price on the exact equipment revision, not
  // the retired purchase-final output fields.
  return purchaseCents(
    basis === 'tax13' ? device.taxInclusivePlanPrice : device.untaxedPlanPrice,
  );
}
